<template>
    <div :class="isEnglishFlag ? 'isEnglish' : 'isChinese'" :style="`background-image: url(${bgcImgUrl})`">
        <div class="goLogin">
            <div class="left">
                <h3>{{ $t('register.hasAccount2') }}</h3>
                <p @click="gotoLogin">
                    <i class="el-icon-sort-down" style="transform: rotate(90deg)"></i>
                    {{ $t('register.back') }}
                </p>
            </div>
            <div class="right">
                <el-form
                    label-position="left"
                    :hide-required-asterisk="false"
                    :model="registerForm"
                    :rules="registerRules"
                    ref="registerForm"
                    :label-width="isEnglishFlag ? '185px' : '85px'">
                    <el-form-item :label="$t('register.username')" prop="name">
                        <el-input maxlength="20" v-model.trim="registerForm.name"
                            :placeholder="$t('register.namePl')" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('register.gender')" prop="sex">
                        <el-radio-group v-model="registerForm.sex">
                            <el-radio :label="1">{{ $t('register.male') }}</el-radio>
                            <el-radio :label="2">{{ $t('register.female') }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item class="label_org" :label="$t('register.department')" prop="org_id">
                        <el-cascader :placeholder="$t('register.inputDepartment')"
                        v-model="pageOrg_id" 
                        :props="orgProps"
                        :show-all-levels="false"
                        clearable
                        :options="orgOptions"
                        @change="handleChange"></el-cascader>
                    </el-form-item>
                    <el-form-item class="label_account" :label="$t('register.account')" prop="number">
                        <el-input maxlength="16" v-model.trim="registerForm.number" :placeholder="$t('rules.account')" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item class="label_account" :label="$t('register.psw')" prop="Tpassword">
                        <el-input type="password" maxlength="16" v-model.trim="registerForm.Tpassword"
                                    :placeholder="$t('register.strongPwd')" autocomplete="off"></el-input>
                    </el-form-item>
                    <!-- 间距太小了，用一个divdom调整一下 -->
                    <div style="height:10px; "></div>
                    <el-form-item :label="$t('register.checkPsw')" prop="repassword">
                        <el-input type="password" maxlength="16" v-model.trim="registerForm.repassword"
                                    :placeholder="$t('register.checkPswPl')" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item class="label_sub" label-width="0">
                        <el-button type="primary" @click="registerAccount('registerForm')">
                            {{ $t('register.submit') }}
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <el-dialog :title="$t('global.tips')" :width="isEnglishFlag ? '450px' : '400px'"
                   :visible.sync="affirmAgain">
            <p class="clear">
                <span>{{ $t('register.rememberTip') }}</span>
                <span class="fr" @click="copyInfo">{{ $t('global.copy') }}</span>
            </p>

            <div class="clear">
                <span class="fl">{{ $t('register.account') }}：</span>
                <input readonly type="text" class="account fr" :value="registerForm.number">
            </div>

            <div class="clear">
                <span class="fl">{{ $t('register.psw') }}：</span>
                <input readonly type="text" class="fr" :value="registerForm.Tpassword">
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="affirmAgain = false">{{ $t('global.cancel') }}</el-button>
                <el-button type="primary" :disabled="createAgain" @click="createAccount">{{ $t('register.confirmed') }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
// import './assets/css/theme/409EFF/index.css';
import '../../assets/css/theme/E62125/index.css';
export default {
    data() {
        let validateAccount = (rule, value, callback) => {
            const reg = /^[\w]{4,16}$/;
            if (value === '') {
                callback(new Error(this.$t('rules.account')));
            } else if (!reg.test(value)) {
                callback(new Error(this.$t('rules.account')));
            } else {
                callback();
            }
        };

        let validatePass = (rule, value, callback) => {
            const reg = /^[\w]{6,16}$/;
            if (value === '') {
                callback(new Error(this.$t('register.pswEmpty')));
            } else if (!reg.test(value)) {
                callback(new Error(this.$t('register.pswtip')));
            } else {
                callback();
            }
        };

        let validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('register.checkTwice')));
            } else if (value !== this.registerForm.Tpassword) {
                callback(new Error(this.$t('register.noSame')));
            } else {
                callback();
            }
        };
        return {
            pageOrg_id: '', //用来v-model联级选择器，不然选中的时候有bug
            bgcImgUrl: "", //背景图地址
            host_addr: sessionStorage.getItem('host_addr'),
            orgOptions: [],
            orgProps: {
                label: 'name',
                value: 'id',
                checkStrictly: true,
            },
            registerForm: {
                name: '',   // 用户名
                sex: 1,   // 性别, 男1，女2
                org_id: '',  //部门
                number: '',   // 账号
                Tpassword: '',   // 密码
                repassword: '',  // 确认密码
                role_id: 6
            },
            registerRules: {
                org_id: [],
                name: [
                    { required: true, message: this.$t('register.nameEmpty'), trigger: 'blur' },
                    // { required: true, validator: validateName, trigger: 'blur' },
                ],
                sex: [
                    { required: true, message: this.$t('register.genderEmpty'), trigger: 'blur' },
                ],
                number: [
                    { required: true, validator: validateAccount, trigger: 'blur' },
                ],
                Tpassword: [
                    { required: true, pattern: this.rules.strongPwd.reg, trigger: 'blur', message: this.$t('rules.strongPwd') },
                ],
                repassword: [
                    { required: true, message: this.$t('register.pswEmpty'), trigger: 'blur' },
                    { validator: validatePass2, trigger: 'blur' },
                ],
            },
            affirmAgain: false,
            createAgain: false
        }
    },
    created() {
        this.getOrg();
        this.getBackgroudPic()
    },
    mounted() {
        this.toggleClass(document.body, 'custom-E62125')
    },
    beforeDestory() {
        this.toggleClass(document.body, 'custom-409EFF')
    },
    computed: {
        isEnglishFlag() {
            return this.$i18n.locale === 'en-us'
        }
    },
    methods: {
        getOrg() {
            let success = res => {
                this.orgOptions = res.data;
            };
            this.$ajax({
                url: "api/org/org",
                method: "get",
                params: {
                    for_company: 1
                },
                func: { success: success }
            });
        },
        gotoLogin() {
            this.$router.replace({path: '/user-login'})
        },
        registerAccount(name) {
            this.$refs[name].validate((valid) => {

                if (valid) {
                    this.affirmAgain = true
                } else {

                }
            });
        },
        createAccount() {
            this.createAgain = true;
            let success = (res => {
                this.affirmAgain = false;
                this.$message.success(this.$t('homepage.Moderated'))
                this.$router.back();
                return
                this.showRegister = false;
                this.$refs.ruleForm.clearValidate();
                this.createAgain = false;
                this.registerForm = {
                    name: '',   // 用户名
                    sex: 1,   // 性别, 男1，女2
                    org_id: '',  //部门
                    number: '',   // 账号
                    Tpassword: '',   // 密码
                    repassword: '',  // 确认密码
                    role_id: 6
                }
            });

            let fail = err => {
                this.$message.error(err.msg);
                this.createAgain = false;
            };

            let params = this.registerForm

            this.$ajax({
                url: 'api/user/user_apply',
                method: 'post',
                data: params,
                func: { success, fail }
            })
        },
        handleChange(value) {
            this.registerForm.org_id = value ? value[value.length - 1] : ''
        },
        copyInfo() {
            let content = document.querySelector('.account');
            content.select();
            document.execCommand('copy');
            this.$message.success(this.$t('global.copySuccess'))
        },
        //获取背景图
        getBackgroudPic() {
            let success = res => {
                this.bgcImgUrl = this.BASE_URL + res.data.back_image;
            };
            this.$ajax({
                url: "api/system/login_set",
                method: "get",
                params: {},
                func: { success: success }
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.isChinese {
    display: flex;
    flex-direction: column;
    height: 100vh;
    min-width: 1152px;
    min-height: 880px;
    background-position: center top;
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .goLogin {
        height: 410px;
        width: 1100px;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%);
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        margin: auto;

        .left {
            width: 410px;
            height: 100%;
            float: left;
            color: #fff;
            font-family: MicrosoftYaHei;
            padding-left: 90px;

            h3 {
                font-size: 32px;
                line-height: 42px;
                margin: 110px 0 34px 0;
            }

            p {
                height: 47px;
                width: 185px;
                line-height: 47px;
                font-size: 22px;
                border: 2px solid #fff;
                text-align: center;
                cursor: pointer;
            }
        }

        .right {
            height: 540px;
            width: 480px;
            background-color: #fff;
            position: absolute;
            left: 500px;
            top: -60px;
            padding: 62px 65px;
            box-sizing: border-box;

            .label_org {
                :deep(.el-form-item__label ){
                    padding-left: 12px;
                }

                :deep(.el-cascader ){
                    width: 265px;
                }
            }

            .label_sub {
                :deep(.el-button ){
                    width: 350px;
                    margin-top: 10px;
                }
            }
        }
    }
}

.isEnglish {
    display: flex;
    flex-direction: column;
    height: 100vh;
    min-width: 1152px;
    min-height: 880px;
    background-position: center top;
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .goLogin {
        width: 1200px;
        height: 410px;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%);
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        margin: auto;

        .left {
            width: 410px;
            height: 100%;
            float: left;
            color: #fff;
            font-family: MicrosoftYaHei;
            padding-left: 90px;

            h3 {
                font-size: 32px;
                line-height: 42px;
                margin: 110px 0 34px 0;
            }

            p {
                height: 47px;
                width: 235px;
                line-height: 47px;
                font-size: 22px;
                border: 2px solid #fff;
                text-align: center;
                cursor: pointer;
            }
        }

        .right {
            height: 540px;
            width: 580px;
            background-color: #fff;
            position: absolute;
            left: 500px;
            top: -60px;
            padding: 60px 65px;
            box-sizing: border-box;

            .label_org {
                margin-bottom: 30px;

                :deep(.el-form-item__label ){
                    padding-left: 12px;
                }

                :deep(.el-cascader ){
                    width: 265px;
                }
            }

            .label_account {
                margin-bottom: 30px;
            }

            .label_sub {
                :deep(.el-button) {
                    width: 450px;
                    margin-top: 10px;
                }
            }
        }
    }
}

.el-dialog {
    margin-top: 300px !important;

    .el-dialog__header {
        padding: 0 22px;
        height: 36px;
        background: #4477C3;

        .el-dialog__title {
            line-height: 36px;
            font-size: 14px;
            color: #fff;
        }

        .el-dialog__headerbtn {
            top: 7px;
            right: 9px;

            .el-dialog__close.el-icon.el-icon-close {
                color: #fff;
            }

        }

    }

    .el-dialog__body {
        padding: 27px 45px;

        >p {
            line-height: 16px;
            font-size: 12px;
            color: #666666;
            cursor: pointer;

            >span {
                &:first-child {}

                &:last-child {
                    font-size: 14px;
                    color: #E62125;
                }
            }
        }

        >div {
            margin-top: 20px;
            height: 40px;
            line-height: 40px;

            >span {
                font-size: 14px;
                color: #000;

            }

            >input {
                float: right;
                box-sizing: border-box;
                display: inline-block;
                padding: 0 13px;
                width: 260px;
                height: 40px;
                border: 1px solid #ddd;
                background: #F8F8F8;
                border-radius: 2px;
            }

        }

    }

    .el-dialog__footer {
        padding: 0;

        .dialog-footer {
            padding: 7px 0 30px;
            text-align: center;
            font-size: 22px;

            .el-button.el-button--default {
                width: 82px;
                color: #fff;
                background: #f8b5bd;
                border: 0 none;
            }

            .el-button.el-button--primary {
                min-width: 170px;
                color: #fff;
                border: 0 none;
            }
        }
    }
}
</style>
